import { render, staticRenderFns } from "./FlowRemarkPopup.vue?vue&type=template&id=1d1c45ab&scoped=true&"
import script from "./FlowRemarkPopup.vue?vue&type=script&lang=ts&"
export * from "./FlowRemarkPopup.vue?vue&type=script&lang=ts&"
import style0 from "./FlowRemarkPopup.vue?vue&type=style&index=0&id=1d1c45ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c45ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDivider,VIcon,VRow,VSelect,VSpacer,VTimeline,VTimelineItem})
